export default {
  select_size: 'Selecteer een maat',
  required: 'Verplicht',
  required_missing: 'Verplicht — maak een keuze',
  optional: 'Optioneel',
  select_up_to: 'Selecteer maximaal {{maxCount}}',
};
